/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} _Field_Enum_Icsrm_In_Praesenz15Inputs */

const en__field_enum_icsrm_in_praesenz15 = /** @type {(inputs: _Field_Enum_Icsrm_In_Praesenz15Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`in person`)
};

const de__field_enum_icsrm_in_praesenz15 = /** @type {(inputs: _Field_Enum_Icsrm_In_Praesenz15Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`in Präsenz`)
};

/**
* | output |
* | --- |
* | "in person" |
*
* @param {_Field_Enum_Icsrm_In_Praesenz15Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const _field_enum_icsrm_in_praesenz15 = /** @type {((inputs?: _Field_Enum_Icsrm_In_Praesenz15Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<_Field_Enum_Icsrm_In_Praesenz15Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en__field_enum_icsrm_in_praesenz15(inputs)
	return de__field_enum_icsrm_in_praesenz15(inputs)
});
export { _field_enum_icsrm_in_praesenz15 as "_field_enum_ICSRM_IN_PRAESENZ" }